/**
 * DevFest 2026 Brand Assets & Design Tokens Registry
 * Source: Official Google DevFest 2026 Brand Guide (goo.gle/devfest26-brand-guide)
 * COMPASS Detroit Community Platform
 */

// Logos
import devfestWordmarkPrimary from '@/assets/devfest2026/logos/devfest-wordmark-primary.png'
import devfestWordmark2026 from '@/assets/devfest2026/logos/devfest-wordmark-2026.png'
import devfestLockupDetroit from '@/assets/devfest2026/logos/devfest-lockup-detroit.png'
import devfestLockupSecondary from '@/assets/devfest2026/logos/devfest-lockup-secondary.png'

// Stickers & Glyphs
import stickerBoldSheet from '@/assets/devfest2026/stickers/stickers-bold-glyphs-sheet.png'
import glyphSpark from '@/assets/devfest2026/stickers/glyph-monoline-spark.png'
import glyphBrackets from '@/assets/devfest2026/stickers/glyph-monoline-brackets.png'
import glyphGear from '@/assets/devfest2026/stickers/glyph-monoline-gear.png'
import glyphCode from '@/assets/devfest2026/stickers/glyph-monoline-code.png'
import glyphTerminal from '@/assets/devfest2026/stickers/glyph-monoline-terminal.png'
import glyphSearch from '@/assets/devfest2026/stickers/glyph-monoline-search.png'
import glyphCube from '@/assets/devfest2026/stickers/glyph-monoline-cube.png'
import glyphDiamond from '@/assets/devfest2026/stickers/glyph-monoline-diamond.png'
import glyphCloud from '@/assets/devfest2026/stickers/glyph-monoline-cloud.png'
import glyphCircuit from '@/assets/devfest2026/stickers/glyph-monoline-circuit.png'
import glyphStar from '@/assets/devfest2026/stickers/glyph-monoline-star.png'
import glyphTag from '@/assets/devfest2026/stickers/glyph-monoline-tag.png'
import glyphBulb from '@/assets/devfest2026/stickers/glyph-monoline-bulb.png'
import glyphCompass from '@/assets/devfest2026/stickers/glyph-monoline-compass.png'
import glyphHeart from '@/assets/devfest2026/stickers/glyph-monoline-heart.png'
import glyphStack from '@/assets/devfest2026/stickers/glyph-monoline-stack.png'
import glyphGlobe from '@/assets/devfest2026/stickers/glyph-monoline-globe.png'
import glyphRocket from '@/assets/devfest2026/stickers/glyph-monoline-rocket.png'
import stickerBadge from '@/assets/devfest2026/stickers/sticker-devfest-badge.png'
import stickerBurst from '@/assets/devfest2026/stickers/sticker-devfest-burst.png'
import stickerShapes from '@/assets/devfest2026/stickers/sticker-devfest-shapes.png'

// Role Badges & Stickers
import roleOrganizer from '@/assets/devfest2026/roles/role-organizer.png'
import roleSpeaker from '@/assets/devfest2026/roles/role-speaker.png'
import roleAttendee from '@/assets/devfest2026/roles/role-attendee.png'
import roleVolunteer from '@/assets/devfest2026/roles/role-volunteer.png'
import roleSponsor from '@/assets/devfest2026/roles/role-sponsor.png'
import roleVip from '@/assets/devfest2026/roles/role-vip.png'
import roleMentor from '@/assets/devfest2026/roles/role-mentor.png'
import roleFacilitator from '@/assets/devfest2026/roles/role-facilitator.png'
import roleCommunity from '@/assets/devfest2026/roles/role-community.png'
import roleNavigator from '@/assets/devfest2026/roles/role-navigator.png'

// Banners & Key Art
import keyartHorizontal from '@/assets/devfest2026/banners/keyart-horizontal.png'
import keyartStacked from '@/assets/devfest2026/banners/keyart-stacked.png'
import bannerEventPlatform from '@/assets/devfest2026/banners/banner-event-platform-2560x650.png'
import bannerLanding1440 from '@/assets/devfest2026/banners/banner-landing-1440x500.png'
import bannerLanding2650 from '@/assets/devfest2026/banners/banner-landing-2650x500.png'

// Animated
import motionSquare1 from '@/assets/devfest2026/animated/devfest-motion-square-1.gif'
import motionSquare2 from '@/assets/devfest2026/animated/devfest-motion-square-2.gif'
import motionSquare3 from '@/assets/devfest2026/animated/devfest-motion-square-3.gif'
import motionSquare4 from '@/assets/devfest2026/animated/devfest-motion-square-4.gif'
import announcement16x9 from '@/assets/devfest2026/animated/devfest-announcement-16x9.gif'
import announcementAnimated16x9 from '@/assets/devfest2026/animated/devfest-announcement-animated-16x9.gif'
import announcementAnimated9x16 from '@/assets/devfest2026/animated/devfest-announcement-animated-9x16.gif'
import findNearYouGif from '@/assets/devfest2026/animated/devfest-find-near-you.gif'

// Developer Badges
import badgeDev1 from '@/assets/devfest2026/badges/badge-developer-profile-1.png'
import badgeDev2 from '@/assets/devfest2026/badges/badge-developer-profile-2.png'
import badgeDev3 from '@/assets/devfest2026/badges/badge-developer-profile-3.png'
import badgeDev4 from '@/assets/devfest2026/badges/badge-developer-profile-4.png'

export const DEVFEST_2026_COLORS = {
  core: [
    {
      name: 'Blue 500',
      hex: '#4285f4',
      textClass: 'text-white',
      dark: false,
      desc: 'Google Blue - Main interactive',
    },
    {
      name: 'Green 500',
      hex: '#34a853',
      textClass: 'text-white',
      dark: false,
      desc: 'Google Green - Success & energy',
    },
    {
      name: 'Yellow 600',
      hex: '#f9ab00',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Google Yellow - Detroit gold marker',
    },
    {
      name: 'Red 500',
      hex: '#ea4335',
      textClass: 'text-white',
      dark: false,
      desc: 'Google Red - Vitality & highlights',
    },
  ],
  halftones: [
    {
      name: 'Halftone Blue',
      hex: '#57caff',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Electric Cyan accent',
    },
    {
      name: 'Halftone Green',
      hex: '#5cdb6d',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Spring Lime accent',
    },
    {
      name: 'Halftone Yellow',
      hex: '#ffd427',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Bright Sunshine accent',
    },
    {
      name: 'Halftone Red',
      hex: '#ff7daf',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Coral Rose accent',
    },
  ],
  pastels: [
    {
      name: 'Pastel Blue',
      hex: '#c3ecf6',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Sky Soft background',
    },
    {
      name: 'Pastel Green',
      hex: '#ccf6c5',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Mint Soft background',
    },
    {
      name: 'Pastel Yellow',
      hex: '#ffe7a5',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Cream Gold background',
    },
    {
      name: 'Pastel Red',
      hex: '#f8d8d8',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Blush Soft background',
    },
  ],
  grayscale: [
    {
      name: 'Off White',
      hex: '#f0f0f0',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Light surface base',
    },
    {
      name: 'Black 02',
      hex: '#1e1e1e',
      textClass: 'text-white',
      dark: false,
      desc: 'Dark surface base',
    },
  ],
  compass: [
    {
      name: 'COMPASS Primary',
      hex: '#efb403',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'COMPASS Gold',
    },
    {
      name: 'Pumpkin',
      hex: '#FFA706',
      textClass: 'text-gray-900',
      dark: true,
      desc: 'Warm Sunrise',
    },
    {
      name: 'Burnt Orange',
      hex: '#EE7D33',
      textClass: 'text-white',
      dark: false,
      desc: 'Detroit Brick',
    },
    {
      name: 'Detroit Lime',
      hex: '#00C605',
      textClass: 'text-white',
      dark: false,
      desc: 'Growth marker',
    },
    {
      name: 'Indigo Pulse',
      hex: '#6366f1',
      textClass: 'text-white',
      dark: false,
      desc: 'Ecosystem link',
    },
  ],
}

export const DEVFEST_LOGOS = [
  {
    id: 'primary',
    name: 'DevFest Wordmark Primary',
    url: devfestWordmarkPrimary,
    tag: 'Official Wordmark',
  },
  {
    id: 'year2026',
    name: 'DevFest 2026 Wordmark',
    url: devfestWordmark2026,
    tag: 'Year Edition',
  },
  {
    id: 'detroit',
    name: 'DevFest Detroit Lockup',
    url: devfestLockupDetroit,
    tag: 'Chapter Edition',
  },
  {
    id: 'secondary',
    name: 'DevFest Secondary Lockup',
    url: devfestLockupSecondary,
    tag: 'Compact',
  },
]

export const DEVFEST_GLYPHS = [
  { id: 'spark', name: 'Spark', url: glyphSpark, category: 'monoline' },
  {
    id: 'brackets',
    name: 'Brackets',
    url: glyphBrackets,
    category: 'monoline',
  },
  { id: 'gear', name: 'Gear', url: glyphGear, category: 'monoline' },
  { id: 'code', name: 'Code', url: glyphCode, category: 'monoline' },
  {
    id: 'terminal',
    name: 'Terminal',
    url: glyphTerminal,
    category: 'monoline',
  },
  { id: 'search', name: 'Search', url: glyphSearch, category: 'monoline' },
  { id: 'cube', name: '3D Cube', url: glyphCube, category: 'monoline' },
  { id: 'diamond', name: 'Diamond', url: glyphDiamond, category: 'monoline' },
  { id: 'cloud', name: 'Cloud', url: glyphCloud, category: 'monoline' },
  { id: 'circuit', name: 'Circuit', url: glyphCircuit, category: 'monoline' },
  { id: 'star', name: 'Star', url: glyphStar, category: 'monoline' },
  { id: 'tag', name: 'Tag', url: glyphTag, category: 'monoline' },
  { id: 'bulb', name: 'Idea Bulb', url: glyphBulb, category: 'monoline' },
  {
    id: 'compass',
    name: 'Compass Tech',
    url: glyphCompass,
    category: 'monoline',
  },
  {
    id: 'heart',
    name: 'Community Heart',
    url: glyphHeart,
    category: 'monoline',
  },
  { id: 'stack', name: 'Tech Stack', url: glyphStack, category: 'monoline' },
  { id: 'globe', name: 'Global GDG', url: glyphGlobe, category: 'monoline' },
  {
    id: 'rocket',
    name: 'Rocket Launch',
    url: glyphRocket,
    category: 'monoline',
  },
  {
    id: 'sheet',
    name: 'Bold Glyphs Sheet',
    url: stickerBoldSheet,
    category: 'bold',
  },
  {
    id: 'badge',
    name: 'DevFest Badge',
    url: stickerBadge,
    category: 'sticker',
  },
  {
    id: 'burst',
    name: 'DevFest Burst',
    url: stickerBurst,
    category: 'sticker',
  },
  {
    id: 'shapes',
    name: 'Geometric Shapes',
    url: stickerShapes,
    category: 'sticker',
  },
]

export const DEVFEST_ROLE_BADGES = [
  {
    id: 'speaker',
    name: 'Speaker',
    role: 'Speaker',
    url: roleSpeaker,
    color: '#4285f4',
  },
  {
    id: 'organizer',
    name: 'Organizer',
    role: 'Organizer',
    url: roleOrganizer,
    color: '#ea4335',
  },
  {
    id: 'attendee',
    name: 'Attendee',
    role: 'Attendee',
    url: roleAttendee,
    color: '#34a853',
  },
  {
    id: 'volunteer',
    name: 'Volunteer',
    role: 'Volunteer',
    url: roleVolunteer,
    color: '#f9ab00',
  },
  {
    id: 'sponsor',
    name: 'Sponsor',
    role: 'Sponsor',
    url: roleSponsor,
    color: '#57caff',
  },
  { id: 'vip', name: 'VIP', role: 'VIP', url: roleVip, color: '#ff7daf' },
  {
    id: 'mentor',
    name: 'Mentor',
    role: 'Mentor',
    url: roleMentor,
    color: '#5cdb6d',
  },
  {
    id: 'facilitator',
    name: 'Facilitator',
    role: 'Facilitator',
    url: roleFacilitator,
    color: '#ffd427',
  },
  {
    id: 'community',
    name: 'Community Lead',
    role: 'Community Lead',
    url: roleCommunity,
    color: '#6366f1',
  },
  {
    id: 'navigator',
    name: 'Navigator',
    role: 'Navigator',
    url: roleNavigator,
    color: '#efb403',
  },
]

export const DEVFEST_BANNERS = [
  {
    id: 'keyart-horizontal',
    name: 'Key Art Horizontal',
    url: keyartHorizontal,
    aspect: '16:9',
  },
  {
    id: 'keyart-stacked',
    name: 'Key Art Stacked',
    url: keyartStacked,
    aspect: 'Square',
  },
  {
    id: 'platform-banner',
    name: 'Event Platform Banner (2560x650)',
    url: bannerEventPlatform,
    aspect: 'Wide',
  },
  {
    id: 'landing-1440',
    name: 'Landing Header (1440x500)',
    url: bannerLanding1440,
    aspect: 'Banner',
  },
  {
    id: 'landing-2650',
    name: 'Landing Header (2650x500)',
    url: bannerLanding2650,
    aspect: 'Ultra-Wide',
  },
]

export const DEVFEST_ANIMATED = [
  {
    id: 'motion-1',
    name: 'DevFest Motion Pulse',
    url: motionSquare1,
    type: 'Square',
  },
  {
    id: 'motion-2',
    name: 'DevFest Motion Wave',
    url: motionSquare2,
    type: 'Square',
  },
  {
    id: 'motion-3',
    name: 'DevFest Code Burst',
    url: motionSquare3,
    type: 'Square',
  },
  {
    id: 'motion-4',
    name: 'DevFest Tech Orbit',
    url: motionSquare4,
    type: 'Square',
  },
  {
    id: 'announcement-16x9',
    name: 'Announcement 16:9 Motion',
    url: announcement16x9,
    type: '16:9',
  },
  {
    id: 'announcement-anim-16x9',
    name: 'DevFest Live 16:9',
    url: announcementAnimated16x9,
    type: '16:9',
  },
  {
    id: 'announcement-anim-9x16',
    name: 'Story Video 9:16',
    url: announcementAnimated9x16,
    type: '9:16',
  },
  {
    id: 'find-near-you',
    name: 'Find DevFest Near You',
    url: findNearYouGif,
    type: 'Interactive',
  },
]

export const DEVFEST_DEV_BADGES = [
  { id: 'badge-1', name: 'AI & Cloud Pioneer', url: badgeDev1 },
  { id: 'badge-2', name: 'Mobile Architecture Lead', url: badgeDev2 },
  { id: 'badge-3', name: 'Open Source Navigator', url: badgeDev3 },
  { id: 'badge-4', name: 'Community Catalyst', url: badgeDev4 },
]

export const OFFICIAL_TEMPLATE_LINKS = [
  {
    title: 'Speaker Templates (Square & 16:9)',
    category: 'Social Media',
    url: 'https://drive.google.com/drive/folders/1TisihLszEuy03KMA2oxxGhoveCwGfI9x?usp=drive_link',
    desc: 'Customizable speaker cards with photos and session titles in Google Drawings.',
  },
  {
    title: 'Conference Presentation Template',
    category: 'Slides',
    url: 'https://docs.google.com/presentation/d/1bTHqCd-ZdfXplMtFIISS_kdRjTVPBkOh85B0rB5ohEM/edit?usp=sharing',
    desc: 'Official 2026 Google Slides presentation deck with pre-styled layouts.',
  },
  {
    title: 'Event Agendas (Print & Digital 9x16)',
    category: 'Agenda',
    url: 'https://drive.google.com/drive/folders/1aRkm20mFEsSdhuxqn__HtVKO65BUvxle',
    desc: 'Editable event agenda templates for digital screens and printed flyers.',
  },
  {
    title: 'Physical Signage (A4, Letter & Meterboards)',
    category: 'Venue Print',
    url: 'https://drive.google.com/drive/folders/1Jee9Nj4Uj3BEgrMPt7ZTxNrVtJYJkEYQ?usp=drive_link',
    desc: 'Large format event signage, meterboards, podium lockups, and vinyl banners.',
  },
  {
    title: 'DevFest Swag (Shirts, Bottles & Badges)',
    category: 'Swag & Print',
    url: 'https://drive.google.com/drive/folders/1wD5MG7twXm6X4MqnxGoqV6EKh3dJ0MIf?usp=drive_link',
    desc: 'Print-ready sticker sheets, lanyard badges, T-shirt designs, and water bottle artwork.',
  },
]
